import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FareRulesDetailComponent } from './fare-rules-detail.component';
import { StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { FareRuleSliderModule } from './fare-rule-slider/fare-rule-slider.module';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { GetFareConditionsStoreService } from '@common/services/my-booking/get-fare-conditions/get-fare-conditions.service';
@NgModule({
  declarations: [FareRulesDetailComponent],
  imports: [CommonModule, StaticMsgModule, TableSliderModule, FareRuleSliderModule],
  exports: [FareRulesDetailComponent],
  providers: [MyBookingItineraryService, GetFareConditionsStoreService, StaticMsgPipe],
})
export class FareRulesDetailModule {}
